import { render, staticRenderFns } from "./ModalDetailsChatbot.vue?vue&type=template&id=3a790f02&scoped=true&"
import script from "./ModalDetailsChatbot.vue?vue&type=script&lang=js&"
export * from "./ModalDetailsChatbot.vue?vue&type=script&lang=js&"
import style0 from "./ModalDetailsChatbot.vue?vue&type=style&index=0&id=3a790f02&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a790f02",
  null
  
)

export default component.exports